import type { CodeTemplate } from "./index";
import { readTemplateStep } from "./readTemplateStep.ts" with { type: "macro" };

type StepFile = { path: string; content: string };

type FullTemplateStep = {
  entryPoint?: string;
  defaultHasOutput: boolean;
  files: StepFile[];
};

export const templateStepFiles: Record<CodeTemplate, FullTemplateStep> = {
  shell: {
    entryPoint: "script.sh",
    defaultHasOutput: false,
    files: readTemplateStep("shell"),
  },

  python: {
    entryPoint: "script.py",
    defaultHasOutput: false,
    files: readTemplateStep("python"),
  },

  typescript: {
    entryPoint: "script.ts",
    defaultHasOutput: false,
    files: readTemplateStep("typescript"),
  },

  react: {
    entryPoint: "App.tsx",
    defaultHasOutput: true,
    files: readTemplateStep("react"),
  },

  agent: {
    entryPoint: "agent.ts",
    defaultHasOutput: false,
    files: readTemplateStep("agent"),
  },
};

export const typescriptTemplateDockerfile = templateStepFiles.typescript.files.find(
  (f) => f.path === "Dockerfile"
)!.content;
